var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F25022",
    d: "M11.429 1.143H1.143v10.286H11.43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A4EF",
    d: "M11.429 12.571H1.143v10.286H11.43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FBA00",
    d: "M22.858 1.143H12.572v10.286h10.286z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB900",
    d: "M22.858 12.571H12.572v10.286h10.286z"
  })));
};
export default SvgMicrosoft;